export enum SpinnerSize {
  Sm = 'spinner-border-sm',
  Default = ''
}
